import { ElementType } from 'react';
import { styled } from 'linaria/react';

export const CarouselControl: ElementType = styled.div<{
  'data-direction'?: 'left' | 'right';
}>`
  position: absolute;
  top: 50%;
  left: ${({ 'data-direction': direction }) =>
    direction === 'left' ? 'var(--carousel-control-margin, 0)' : 'inherit'};
  right: ${({ 'data-direction': direction }) =>
    direction === 'right' ? 'var(--carousel-control-margin, 0)' : 'inherit'};
  z-index: 2;
  margin-right: 0;
  transform: translateY(-50%)
    translateX(${({ 'data-direction': direction }) => (direction === 'left' ? '-50%' : '50%')});
`;
